export default __webpack_public_path__ + "static/media/cat4-3.9779db5b.jpg";